export default {
  leaguesData: [],
  selectedTeams: [],
  selectedLeague: "",
  isLoaded: false,
  promoConfig: null,
  promoContent: null,
  selectedLeagueId: "",
  userPick: null,
  editState: false,
  leagueTable: null,
  leagueMatches: null,
  focusedCharacter: null,
  promoStatus: null,
  apiData: null
};
